import { inflate } from 'pako/lib/inflate';
import jwtDecode from 'jwt-decode';
import * as base64 from 'base64-js';
import { AccessTokenPayload } from '../types';

type DecodedAccessToken = {
  iat: number;
  exp: number;
  deflated: boolean;
  payload: string | AccessTokenPayload;
};

export default function decodeAccessToken(accessToken: string): {
  accessToken: DecodedAccessToken;
  payload: AccessTokenPayload;
} {
  const decoded = jwtDecode<DecodedAccessToken>(accessToken);

  if (decoded.deflated) {
    const payloadBytes = base64.toByteArray(decoded.payload as string);
    const payload = JSON.parse(inflate(payloadBytes, { to: 'string' }));

    return { payload, accessToken: decoded };
  }

  return {
    accessToken: decoded,
    payload: decoded.payload as AccessTokenPayload,
  };
}
